// FreeConsultation.js
import React, { useState } from "react";
import "./FreeConsultation.css";

const FreeConsultation = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted data:", formData);
    alert("Thank you! We’ll contact you shortly.");
    setFormData({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <div className="consultation-container">
      <h2 className="consultation-title">Book a Free Consultation</h2>
      <form className="consultation-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Full Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder="Your Message (Optional)"
          value={formData.message}
          onChange={handleChange}
          rows={4}
        />
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default FreeConsultation;
